
"use client";

import { useEffect } from "react";
import { useSleepDialog } from "./sleep/hooks";
import { SleepDialogContainer } from "./sleep/components/SleepDialogContainer";

interface SleepDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  childId?: string;
  activityToEdit?: any;
  onSuccess?: () => void;
}

declare global {
  interface Window {
    refreshSleepHistory?: () => Promise<void>;
    refreshNapHistory?: () => Promise<void>;
  }
}

export function SleepDialog({ 
  open, 
  onOpenChange, 
  childId, 
  activityToEdit, 
  onSuccess 
}: SleepDialogProps) {
  const {
    form,
    saving,
    currentStep,
    showConfirmation,
    locations,
    environments,
    onsetMethods,
    sounds,
    soundLevels,
    restfulnessRatings,
    selectedChild,
    handleClose,
    nextStep,
    prevStep,
    onSubmit,
    setShowConfirmation,
    loadLookupData
  } = useSleepDialog({
    open,
    onOpenChange,
    childId,
    activityToEdit,
    onSuccess
  });

  // Load lookup data
  useEffect(() => {
    if (open) {
      loadLookupData();
    }
  }, [open, loadLookupData]);

  return (
    <SleepDialogContainer
      open={open}
      onOpenChange={onOpenChange}
      form={form}
      saving={saving}
      currentStep={currentStep}
      showConfirmation={showConfirmation}
      locations={locations}
      environments={environments}
      onsetMethods={onsetMethods}
      sounds={sounds}
      soundLevels={soundLevels}
      restfulnessRatings={restfulnessRatings}
      selectedChild={selectedChild}
      handleClose={() => handleClose(false)}
      nextStep={nextStep}
      prevStep={prevStep}
      onSubmit={onSubmit}
      setShowConfirmation={setShowConfirmation}
    />
  );
}
